export type ModalType =
  | ""
  | "abandonmentModal"
  | "cookies"
  | "creatingPassword"
  | "debug"
  | "errorModal"
  | "exponea"
  | "forgotPassword"
  | "maintenance"
  | "outdatedData"
  | "resetPassword"
  | "salesmanOnboarding"
  | "signUpConfirm"
  | "subscription"
  | "verifyEmail"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function showModal(modalType: ModalType, params?: any) {
  return {
    type: "MODALS_SHOW",
    modalType,
    params,
  }
}

export function hideModal(modalType: ModalType) {
  return {
    type: "MODALS_HIDE",
    modalType,
  }
}
